'use client';
import { useAuth } from '@/features/authentication/hooks/auth';
import Preloader from '@/features/preloader/components/Preloader';
import { usePathname, useRouter } from 'next/navigation';

export default function DashboardLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const router = useRouter();
  const pathName = usePathname();

  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <Preloader />;
  }

  if (!user) {
    router.push(`/login?redirect=${pathName}`);
  }

  return (
    <div className="dashboard-container">
      <main>{children}</main>
    </div>
  );
}
